import { CustomParams, CustomParamsUser } from '../google-analytics/ga4Types';
import { FirebaseAdapter } from './firebaseAdapter';
import { createConfigParametersRepository } from '../../configParametersRepository';
import { ECommerce4Transaction } from '../eCommerceTrackingClient/types';

export interface FirebaseClient {
  setUserProperties(params: CustomParamsUser): void;
  trackEvent(params: CustomParams): void;
  trackScreenView(params: CustomParams): void;
  trackECommerce(transaction: ECommerce4Transaction): void;
}

export const createFirebaseClient = (
  firebaseAdapter: FirebaseAdapter
): FirebaseClient => {
  return {
    setUserProperties: (params) => {
      const { getGenericParameters } = createConfigParametersRepository();
      const { isNativeInterface } = getGenericParameters();
      if (!isNativeInterface) {
        return;
      }
      Object.entries(params).forEach(([key, value]) => {
        firebaseAdapter.setUserProperty(key, value);
      });
    },
    trackEvent: (params) => {
      const { getGenericParameters } = createConfigParametersRepository();
      const { isNativeInterface } = getGenericParameters();
      if (!isNativeInterface) {
        return;
      }
      firebaseAdapter.trackEvent('edo_event', {
        ...params,
        edo_timestamp: Date.now(),
      });
    },
    trackScreenView: (params) => {
      const { getGenericParameters } = createConfigParametersRepository();
      const { isNativeInterface } = getGenericParameters();
      if (!isNativeInterface) {
        return;
      }
      firebaseAdapter.trackEvent('edo_screen_view', {
        ...params,
        edo_timestamp: Date.now(),
      });
    },
    trackECommerce: (transaction) => {
      const { getGenericParameters } = createConfigParametersRepository();
      const { isNativeInterface } = getGenericParameters();
      if (!isNativeInterface) {
        return;
      }
      const firebaseTransactionObject = {
        ...transaction,
        currency: 'EUR',
        edo_timestamp: Date.now(),
      };
      firebaseAdapter.trackEvent('purchase', firebaseTransactionObject);
    },
  };
};
